import { Download } from "lucide-react";
import { utils, writeFile } from "xlsx";
import { VButton } from "@/components/ui";
import type { RentedAssetRow, ReportRow } from "@/domains/reporting/api/types";

type ExportButtonProps = {
  rows: ReadonlyArray<ReportRow>;
  filename?: string;
};

export function ExportButton({
  rows,
  filename = "camerabeheer-rapport.xlsx",
}: ExportButtonProps): React.JSX.Element {
  const handleExport = (): void => {
    if (rows.length === 0) return;
    const data = rows.map((r) => ({
      Dossiernummer: r.caseNumber,
      Titel: r.title,
      Type: r.type,
      Adres: r.address,
      Stadsdeel: r.district,
      Begin: r.startDate,
      Eind: r.endDate,
      "Duurtijd (dagen)": r.durationDays,
      "Aantal assets": r.assetCount,
      "Reden inzet": r.reason,
    }));
    const sheet = utils.json_to_sheet(data);
    const book = utils.book_new();
    utils.book_append_sheet(book, sheet, "Inzet");
    writeFile(book, filename);
  };

  return (
    <VButton variant="outline" onClick={handleExport} disabled={rows.length === 0}>
      <Download className="size-4" aria-hidden />
      Exporteer naar Excel
    </VButton>
  );
}

type RentedAssetExportButtonProps = {
  rows: ReadonlyArray<RentedAssetRow>;
  filename?: string;
};

export function RentedAssetExportButton({
  rows,
  filename = "verhuurde-assets-snapshot.xlsx",
}: RentedAssetExportButtonProps): React.JSX.Element {
  const handleExport = (): void => {
    if (rows.length === 0) return;
    const data = rows.map((r) => ({
      Assetnummer: r.number,
      Naam: r.name,
      Type: r.typeLabel,
      Dossiernummer: r.caseNumber,
      Dossier: r.caseTitle,
      Adres: r.address,
      Stadsdeel: r.district,
      Begin: r.startDate,
      Eind: r.endDate,
      "Dagen resterend": r.daysRemaining,
    }));
    const sheet = utils.json_to_sheet(data);
    const book = utils.book_new();
    utils.book_append_sheet(book, sheet, "Verhuurde assets");
    writeFile(book, filename);
  };

  return (
    <VButton variant="outline" onClick={handleExport} disabled={rows.length === 0}>
      <Download className="size-4" aria-hidden />
      Verhuurde assets (snapshot)
    </VButton>
  );
}
